<template lang="pug">
  .component-create-entity-button
    .row.column.card.p-3
      .row
        .column
          label Parking Groups
            SelectizeParkingGroup(:maxItems="null", @optionSelected="add", @optionRemoved="remove", ref="select")
          base-list(:component="component", :dataLoader="dataLoader", componentType="federationList" v-model="selected.delete", :selectableList="true", :resultsPerPage="5", ref="list")
      .row
        ActionButton(:action="save") Save

</template>
<script type="text/babel">

  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import BaseList from './BaseList'
  import SelectizeVehicle from '../../components/structure/ui/lists/selectize/SelectizeVehicle'
  import SelectizeGroupedParkingAssets
    from '../../components/structure/ui/lists/selectize/SelectizeGroupedParkingAssets'
  import SelectizeParkingGroup from '../../components/structure/ui/lists/selectize/SelectizeParkingGroup'
  import SelectizeClient from '../../components/structure/ui/lists/selectize/SelectizeClient'
  import ActionButton from '../../components/structure/ui/ActionButton'

  export default {
    name: 'FederationParkingGroupsEdit',
    components: {
      ActionButton,
      SelectizeClient, SelectizeParkingGroup, SelectizeGroupedParkingAssets, SelectizeVehicle, BaseList
    },
    data() {
      return {
        entity: null,
        loadedItems: [],
        component: require('src/components/backoffice/ParkingGroup.vue'),
        selected: {

          add: [],
          delete: [],

        },
        body: {
          name: []
        }
      }
    },
    created() {
      if (this.item !== null) {
        for (let key in this.item) {
          this.entity[key] = this.item[key]
        }
      }
    },
    methods: {
      add(val) {
        const position = this.loadedItems.indexOf('' + val.id)
        if (position !== -1) {
          this.selected.add.splice(position, 1)
          this.selected.delete.push(val.id)
        } else {
          this.selected.add.push('' + val.id)
        }
      },
      remove(val) {
        const position = this.loadedItems.indexOf('' + val.id)
        this.selected.add.splice(position, 1)
      },
      save() {
        const body = {
          'entity': 'parking_group',
          ...this.selected
        }

        return KeplerBackofficeSdk.federations.select(this.$route.params.id).updateFederated(body, () => {
          this.$refs.list.loadData(1)
          this.$refs.select.clearSelected()
          this.selected.add = []
          this.selected.delete = []
        })
      },
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk[`${this.$route.meta.name}`].select(this.$route.params.id).get((data) => {
          callback(data)
          this.loaded = true
          this.loadedItems = data.items.map((item) => {
            return '' + item.id
          })

        }, () => {
        }, page, resultsPerPage)
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// FederationParkingGroupsEdit.vue?5e464769